import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { graphql, withApollo } from 'react-apollo';
import {
  Message,
  Container,
  Input,
  Dropdown,
  Grid,
  Form,
  TextArea,
  Button,
  Dimmer,
  Loader,
  Header,
} from 'semantic-ui-react';
import { isEmpty, startsWith } from 'lodash';
import SearchResonse from './searchResponse';
import supportRequestMutation from '../../graphql/supportRequestMutation';
import apmsPath from '../../constants/apmsPath';

function flattenParams(params) {
  let paramters = '';
  const list = Object.keys(params);
  list.forEach(i => {
    if (!isEmpty(params[i].key) && !isEmpty(params[i].value)) {
      paramters = `${paramters}&${params[i].key}=${params[i].value}`;
    }
  });
  return paramters;
}

function processBody(body) {
  try {
    const obj = JSON.parse(body);
    return JSON.stringify(obj);
  } catch (error) {
    return '';
  }
}

function isBodyValid(body) {
  if (!isEmpty(processBody(body))) {
    return true;
  }
  return false;
}

function listSelectablePath() {
  const path = apmsPath.pathList.map(param => (
    <option key={param} value={param}>
      {param}
    </option>
  ));
  return <datalist id='path'>{path}</datalist>;
}

class SupportRequestForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      path: '',
      body: '',
      method: 'GET',
      pathNotValid: false,
      bodyNotValid: false,
      type: 'apms_process',
      response: {
        responseCode: '',
        requestUrl: '',
        responseBody: '',
      },
      errorMsg: '',
      parameters: {
        param_1: { key: '', value: '' },
      },
    };
    this.baseState = this.state;
  }

  addParameter = () => {
    const { parameters } = this.state;
    const count = Object.keys(parameters).length;
    if (count < 5) {
      const parameterList = { ...parameters };
      parameterList['param_' + count + 1] = { key: '', value: '' };
      this.setState({ parameters: parameterList });
    }
  };

  parameterChangeKey = (e, { value }) => {
    const { parameters } = this.state;
    const newParameters = { ...parameters };
    newParameters[e.target.name].key = value;
    this.setState({ parameters: newParameters });
  };

  parameterChangeValue = (e, { value }) => {
    const { parameters } = this.state;
    const newParameters = { ...parameters };
    newParameters[e.target.name].value = value;
    this.setState({ parameters: newParameters });
  };

  textChange = (e, { value }) => {
    this.setState({
      body: value,
    });
  };

  updatePath = (e, { value }) => {
    this.validate({ name: 'path', value });
    this.setState({
      path: value,
    });
  };

  updateMethod = (e, { value }) => {
    this.setState({
      method: value,
    });
  };

  updateType = (e, { value }) => {
    this.setState({
      type: value,
    });
  };

  checkValidation = () => {
    this.resetError();
    const { path, body } = this.state;
    const checkPath = this.validate({ name: 'path', value: path });
    const checkBody = this.validate({ name: 'body', value: body });

    if (checkPath && checkBody) {
      return true;
    }
    this.resetResponse();
    return false;
  };

  resetError = () => {
    this.setState({ errorMsg: '', pathNotValid: false, bodyNotValid: false });
  };

  resetResponse = () => {
    this.setState({
      response: this.baseState.response,
    });
  };

  validate = arg => {
    switch (arg.name) {
      case 'body': {
        if (!isEmpty(arg.value) && !isBodyValid(arg.value)) {
          this.setState({ bodyNotValid: true });
          return false;
        }
        this.setState({ bodyNotValid: false });
        break;
      }
      case 'path': {
        if (isEmpty(arg.value)) {
          this.setState({ pathNotValid: true, errorMsg: '' });
          return false;
        } if (!startsWith(arg.value, '/')) {
          this.setState({
            pathNotValid: true,
            errorMsg: 'Path Must Begin With /',
          });
          return false;
        }
        this.setState({ pathNotValid: false, errorMsg: '' });
        return true;
      }
      default: {
        if (isEmpty(arg.value) || arg.value === '' || arg.value === undefined) {
          this.setState({ bodyNotValid: true });
          return false;
        }
      }
    }
    return true;
  };

  handleSubmit = event => {
    event.preventDefault();
    if (this.checkValidation()) {
      this.setState({ loading: true });
      const { postSupportRequest } = this.props;
      const {
        path, method, body, parameters, type,
      } = this.state;
      const params = flattenParams(parameters);
      const parsedBody = processBody(body);

      postSupportRequest({
        variables: {
          input: {
            support_request: {
              requestParameter: params,
              requestPath: path,
              type,
              requestBody: parsedBody,
              requestMethod: method,
            },
          },
        },
      })
        .then(({ data }) => {
          const {
            postSupportRequest: { support_request: supportRequest },
          } = data;
          this.setState({ response: supportRequest, loading: false });
        })
        .catch(() => {
          this.setState({
            errorMsg: 'Error Processing API Request.',
            loading: false,
          });
        });
    } else {
      this.setState({
        errorMsg: 'Complete Missing Form Fields',
        loading: false,
      });
    }
  };

  listParamter = () => {
    const { parameters, loading } = this.state;
    const paramsKeys = Object.keys(parameters);
    const listParamters = paramsKeys.map((param, index) => {
      const key = `${param}_${index}`;

      return (
        <Form.Group key={key + '_group'}>
          <Form.Input
            placeholder='Key'
            name={param}
            key={key + '_key'}
            onChange={this.parameterChangeKey}
            value={parameters[param].key}
            disabled={loading}
          />
          <Form.Input
            placeholder='Value'
            name={param}
            key={key + '_value'}
            onChange={this.parameterChangeValue}
            value={parameters[param].value}
            disabled={loading}
          />
          {index === 0 && (
            <Form.Button
              content='+'
              onClick={this.addParameter}
              disabled={loading}
            />
          )}
        </Form.Group>
      );
    });
    return listParamters;
  };

  clearForm = () => {
    this.setState(this.baseState);
    this.setState({
      parameters: {
        param_1: { key: '', value: '' },
      },
    });
  };

  requestType = [
    { key: 1, text: 'Assurance Manager Processor', value: 'apms_process' },
    { key: 2, text: 'Assurance Manager Event Processor', value: 'apms_event' },
  ];

  requestMethod = [
    { key: 1, text: 'GET', value: 'GET' },
    { key: 2, text: 'POST', value: 'POST' },
    { key: 3, text: 'DELETE', value: 'DELETE' },
    { key: 4, text: 'PUT', value: 'PUT' },
  ];

  render() {
    const {
      method,
      response,
      errorMsg,
      path,
      body,
      type,
      pathNotValid,
      bodyNotValid,
      loading,
    } = this.state;
    return (
      <div>
        <Container fluid>
          <Message>
            <Message.Header>Support Request Tool</Message.Header>
            <p>
              Use the tool below to post request to APMS manually. For
              additional information on request path and Payload, use the
              provided document link.
            </p>
            <br />
            <p>
              <a
                target='_blank'
                href='https://pages.ghe.coxautoinc.com/InventorySolutions-DealShield/Tappy-Integration-Doc/'
                rel='noreferrer'
              >
                Access Request Document
              </a>
            </p>
          </Message>
        </Container>

        <br />

        <Grid columns={2} padded divided>
          <Grid.Column>
            <Container>
              <container>
                <Dimmer
                  active={loading}
                  verticalAlign='top'
                  className='dimmer-center'
                >
                  <Header as='h3' inverted>
                    <Loader active inline='centered' size='large' />
                    <br />
                    Processing...
                  </Header>

                  <Button primary onClick={this.clearForm}>
                    Cancel Request
                  </Button>
                </Dimmer>
              </container>

              {!isEmpty(errorMsg) && (
                <Message negative>
                  <b>
                    <p>{errorMsg}</p>
                  </b>
                </Message>
              )}
              <br />
              <Grid container columns={2}>
                <Grid.Row>
                  <Grid.Column width={3}>
                    <b>Select Host</b>
                  </Grid.Column>
                  <Grid.Column>
                    <Dropdown
                      value={type}
                      options={this.requestType}
                      onChange={this.updateType}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column
                    width={3}
                    verticalAlign='middle'
                    columns={2}
                    padded='vertically'
                  >
                    <b>Request Path</b>
                  </Grid.Column>
                  <Grid.Column>
                    <Input
                      fluid
                      error={pathNotValid}
                      list='path'
                      labelPosition='left'
                      placeholder='Request Path'
                      onChange={this.updatePath}
                      value={path}
                      disabled={loading}
                    />
                    {listSelectablePath()}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={3} verticalAlign='middle' columns={2}>
                    <b>Method</b>
                  </Grid.Column>
                  <Grid.Column>
                    <Dropdown
                      button
                      options={this.requestMethod}
                      text={method}
                      onChange={this.updateMethod}
                      value={method}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={3} verticalAlign='top'>
                    <b>Parameters</b>
                  </Grid.Column>
                  <Grid.Column>
                    <Form>{this.listParamter()}</Form>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={3} columns={2}>
                    <b>Body (JSON)</b>
                  </Grid.Column>
                  <Grid.Column width={12}>
                    {bodyNotValid && <p>* Payload Format Not Valid (JSON) </p>}
                    <Form>
                      <TextArea
                        style={{ height: '200px' }}
                        placeholder='request body'
                        onChange={this.textChange}
                        value={body}
                        disabled={loading}
                      />
                    </Form>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={3} columns={2} />
                  <Grid.Column>
                    <div>
                      <Button
                        content='Clear'
                        secondary
                        onClick={this.clearForm}
                        disabled={loading}
                      />
                      <Button
                        content='Send APMS Request'
                        primary
                        onClick={this.handleSubmit}
                        disabled={loading}
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              <br />
            </Container>
          </Grid.Column>
          <Grid.Column>
            <SearchResonse response={response} />
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

SupportRequestForm.propTypes = {
  postSupportRequest: PropTypes.func.isRequired,
};

export default compose(
  withApollo,
  graphql(supportRequestMutation, { name: 'postSupportRequest' })
)(SupportRequestForm);
